import React from "react";

import { AndroidInterstitial } from "../../../MVVM/Components/AndroidInterstitial";
import { ClipModal } from "../../../MVVM/Components/Modals/Clip";
import { ClipModals } from "../../../MVVM/Components/Modals/ClipModals";
import { CrossSitePromotion } from "../../../MVVM/Views/CrossSitePromotion";
import { DebugModal } from "../../../MVVM/Components/Modals/DebugModal";
import { DemoUploaderModal } from "../../../MVVM/Components/Modals/DemoUploader/";
import { ECrossSitePromotionType } from "../../../MVVM/@types";
import { AnnualUpsellModal } from "../Modals/AnnualUpsell";
import { ExpiredSubscriptionUpsell } from "../Modals/ExpiredSubscriptionUpsell";
import { TrialReactivationUpsell } from "../Modals/TrialReactivationUpsell";
import { CreatorCreditsAnnouncement } from "../Modals/CreatorCreditsAnnouncement";

import { RemoveConflictingCardsModal } from "../../../MVVM/Components/Modals/RemoveConflictingCards";
import { SignupModal } from "../../../MVVM/Components/Modals/Signup";
import { SimpleClipViewModal } from "../../../MVVM/Components/Modals/SimpleClipViewer";
import { StripePayStation } from "../../../MVVM/Components/Modals/StripePaystation";
import { StudioFTUEModal } from "../../../MVVM/Components/Modals/StudioFTUE";

import { YoutubeUnavailable } from "../../../MVVM/Components/Modals";
import { SetRiotRegionModal } from "../Modals/SetRiotRegion";
import { Box } from "rebass/styled-components";
import { DiscordSupportModal } from "../Modals/DiscordSupport";
import { SignatureModal } from "../Modals/Signature";
import { GlobalStorageAddonModal } from "../Modals/StorageAddonModal/GlobalStorageAddonModal";
import { ManageOnMobile } from "../Modals/ManageOnMobile";
import { MatchVodViewer } from "../MatchVodViewer";
import { WelcomeSeriesModal } from "../Modals/WelcomeSeries";
import { WelcomeSeriesDebugTrigger } from "../Modals/WelcomeSeries/DebugTrigger";

const ModalManager = () => (
  <Box id="modal-root">
    <AndroidInterstitial />
    <AnnualUpsellModal />
    <ExpiredSubscriptionUpsell />
    <TrialReactivationUpsell />
    <ClipModal />
    <ClipModals />
    <CrossSitePromotion type={ECrossSitePromotionType.FirstLandTakeover} />
    <CreatorCreditsAnnouncement />
    <DebugModal />
    <DemoUploaderModal />
    <RemoveConflictingCardsModal />
    <SignupModal />
    <SimpleClipViewModal />
    <StripePayStation />
    <StudioFTUEModal />

    <YoutubeUnavailable />
    <SetRiotRegionModal />
    <SignatureModal />
    <DiscordSupportModal />
    <GlobalStorageAddonModal />
    <ManageOnMobile />
    <MatchVodViewer />
    <WelcomeSeriesModal />
    <WelcomeSeriesDebugTrigger />
  </Box>
);

export { ModalManager };
